import axios from "axios";
import { defaultCurrency } from "../helpers/helpers";

const Auth = {
	setToken(token, user) {
		const User = JSON.stringify(user);
		localStorage.setItem("user", User);
		localStorage.setItem("token", token);
		axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
		axios.defaults.timeout = 120000;
	},
	getToken() {
		let token = localStorage.getItem("token");
		if (!token) {
			return null;
		} else {
			return token;
		}
	},
	setUser(user) {
		const User = JSON.stringify(user);
		localStorage.setItem("user", User);
	},
	getUser() {
		return JSON.parse(localStorage.getItem("user"));
	},
	setCouple(couple) {
		const Couple = JSON.stringify(couple);
		localStorage.setItem("couple", Couple);
	},
	getCouple() {
		return JSON.parse(localStorage.getItem("couple"));
	},
	isAuthenticated() {
		if (this.getToken()) return true;
		return false;
	},
	getCurrency() {
		const curr = localStorage.getItem("currency");
		if (curr === "undefined") {
			localStorage.removeItem("currency");
			this.setCurrency(defaultCurrency);
			return;
		}
		const currency = JSON.parse(curr);
		return currency;
	},
	destroyToken() {
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("couple");
		localStorage.removeItem("experience");
		delete axios.defaults.headers.common["Authorization"];
		return true;
	},
	setCurrency(currency) {
		const Currency = JSON.stringify(currency);
		localStorage.setItem("currency", Currency);
	},
	setExperience(experience) {
		const xp = JSON.stringify(experience);
		localStorage.setItem("experience", xp);
	},
	getExperience() {
		return JSON.parse(localStorage.getItem("experience"));
	},
};

export default Auth;
